export function registerServiceWorker() {
  if (
    process.env.NODE_ENV !== "production" ||
    typeof window === "undefined" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  const register = () => {
    const swUrl = `${process.env.BASE_URL || "/"}service-worker.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      // Service worker registration failed (e.g. unsupported protocol)
    });
  };

  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
}
